import { createSelector } from 'reselect';
import { shouldShowChannelCover } from '@wix/wix-vod-shared/src/common/utils/overlay-buttons-utils';
import { getChannelForWidget } from '@wix/wix-vod-shared/src/common/selectors/channels';


const getVideo = (state, props) => props.videoItem;
const getShowChannelCover = (state, props) => props.showChannelCover;
const getSettings = state => state.appSettings;

export const getPlayerCoverUrl = createSelector(
  [
    getSettings,
    getChannelForWidget,
    getVideo,
    getShowChannelCover,
  ],
  (settings, channel, video, showChannelCover) => {

    const { customCoverUrl, coverUrl } = video;

    let url = customCoverUrl || coverUrl;

    if (shouldShowChannelCover(settings, showChannelCover)) {
      url = channel.customCoverUrl || channel.coverUrl || url;
    }

    return url;
  }
);



// WEBPACK FOOTER //
// ./src/mobile/views/home/components/cover-with-overlay/player-cover-selector.js